<template>
    <div class="OrderList">
    <GlobalInfoBar title="差价订单" content="查看或处理门店的差异订单，与小程序差价订单同步" />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <!-- <OrderFrom :classList="classList" v-if="classList"/> -->
        <OrderFrom/>
      </div>
      <div class="caseOrder">
          <OrderTable/>
      </div>
    </GlobalChunk>
  </div>
</template>

<script>
import _api from "@/utils/request";
import OrderFrom from "./From"
import OrderTable from "./table"
export default {
  name: "OrderList",
  components:{OrderFrom,OrderTable},
  data() {
    return {
      classList: null,
      merchantId: '',
    };
  },
  created() {

    // this.getClassList()
    // this.getResidentList()
  },
  methods: {
    // 获取分类集合
    // getClassList() {
    //   _api.selectList().then(res => {
    //     console.log(res)
    //     this.classList = res.data?res.data:[]
    //   })
    // },
  }
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.OrderList {
  .case {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .case-title {
      display: flex;
      .case-title_icon {
        width: 20px;
        height: 20px;
      }
      .case-title_max {
        font-weight: bold;
        color: #333333;
        font-size: 18px;
        width: 80px;
        height: 17px;
        line-height: 17px;
        font-family: FZLanTingHei-B-GBK;
      }
    }
  }
  .caseOrder {
        margin: 20px 5px;
        background: #f5f6fa;
        border-radius: 10px;
    }
}
</style>
